import { render, staticRenderFns } from "./Quiz.vue?vue&type=template&id=23910b76&scoped=true&"
import script from "./Quiz.vue?vue&type=script&lang=ts&"
export * from "./Quiz.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23910b76",
  null
  
)

export default component.exports